import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import { FinishTypeOption, QuantityCalculationMethodOption, RoundOption } from '@/utils/constants';
import { validatorRequireNumber } from '@/utils/validators';

import baseCrudMixin from '@/mixins/crud';

export default {
  computed: {
    formDefinition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    },
    roundOptionValue() {
      return this.$store.getters['editor/value']('roundOption');
    },
    finishTypeIDValue() {
      return this.$store.getters['editor/value']('finishTypeID');
    },
    finishType: function() {
      if (!this.finishTypeIDValue) {
        return null;
      }
      return this.$store.getters['finishType/getLoadedItemByID'](this.finishTypeIDValue);
    },
    products() {
      return this.$store.getters['products/loadedItems'];
    }
  },
  mixins: [baseCrudMixin],
  watch: {
    roundOptionValue(roundOption) {
      const required = this.showParityOption(roundOption);
      this.definition.parityOption.rules = required ? [{ validator: validatorRequireNumber }] : [];
    },
    finishTypeIDValue() {
      this.loadProducts();
    },
    formDefinition(definition) {
      this.definition = definition;
    },
    products(products) {
      this.getColumn('defaultProductID').filter.options = products;
    }
  },
  data: () => ({
    entity: 'Finish',
    returnTo: 'Finishes',
    definition: {}
  }),
  created() {
    this.definition = this.createDefinition();
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData,
    isFabricWidthFactorRequired() {
      const finishType = this.finishType;
      return !!finishType && finishType.fabricWidthFactorRequiredYN;
    },
    isHeadingHeightRequired() {
      const finishType = this.finishType;
      return !!finishType && finishType.finishTypeOption === FinishTypeOption.Fixture;
    },
    isProductTypeRequired() {
      const finishType = this.finishType;
      return !!finishType && finishType.requiredProductTypeID !== null;
    },
    isExtraFabricHeightApplicable() {
      const finishType = this.finishType;
      return !!finishType && finishType.extraFabricHeightApplicableYN;
    },
    isExtraFabricWidthApplicable() {
      const finishType = this.finishType;
      return !!finishType && finishType.extraFabricWidthApplicableYN;
    },
    isPleats() {
      const finishType = this.finishType;
      return !!finishType && finishType.calculationMethodOption === QuantityCalculationMethodOption.Pleats;
    },
    showRoundOption() {
      return this.showQuantityFormula();
    },
    showParityOption(roundOption) {
      return (
        this.showRoundOption() &&
        (roundOption === RoundOption.Standard || roundOption === RoundOption.Up || roundOption === RoundOption.Down)
      );
    },
    showQuantityFormula() {
      const finishType = this.finishType;
      if (!finishType) {
        return false;
      }
      const method = finishType.calculationMethodOption;
      return method === QuantityCalculationMethodOption.Formula || method === QuantityCalculationMethodOption.Pleats;
    },
    loadProducts() {
      const finishType = this.finishType;
      if (!!finishType && !!finishType.requiredProductTypeID) {
        const params = {
          query: {
            productTypeID: finishType.requiredProductTypeID
          }
        };
        this.$store.dispatch('product/getItems', params);
      }
    }
  }
};
